import { Box, Icon, Text } from '@jfs/ui-new'
import { Colors } from '../../util/util'
import { SvgImage } from '../SvgImage'

export const DownloadInfo = ({ hide = false, onDismiss, message }: any) => {
  if (hide) {
    return null
  }
  return (
    <Box position={'absolute'} zIndex={10} top={52} left={24} right={24}>
      <Box align="flex-end" marginRight={8}>
        <SvgImage color={Colors.PRIMARY} imageName={'triangle'} />
      </Box>
      <Box
        bg={'PRIMARY'}
        borderRadius={8}
        gap={12}
        flexDirection={'row'}
        p={16}
        justify={'space-between'}
        align={'center'}
        f={1}>
        <Box f={1}>
          <Text fontFamily={'SouceSans3-Medium'} fontSize={12} color={'WHITE'} lineHeight={18} letterSpacing={-0.06}>
            {message}
          </Text>
        </Box>
        <Box onPress={onDismiss} testID="close-DownloadInfo" underlayColor={'TRANSPARENT'}>
          <Icon id={'CLOSE'} color={'WHITE'} size={16} />
        </Box>
      </Box>
    </Box>
  )
}
